import type { MediaItem } from "../../types/dashboard";
import { Modal } from "./Modal";

// Enlarged lightbox preview for a single media item, shared by the Media
// library and the Playlist editor. Reuses the app Modal (Esc + backdrop
// close); renders nothing when `item` is null.
export function MediaPreview({
  item,
  onClose,
}: {
  item: MediaItem | null;
  onClose: () => void;
}) {
  return (
    <Modal open={!!item} onClose={onClose} ariaLabel="Media preview" width="auto">
      {item && (
        <div className="media-preview">
          <button
            type="button"
            className="media-preview-close"
            onClick={onClose}
            aria-label="Close preview"
          >
            ×
          </button>
          {item.mime_type?.startsWith("video") ? (
            <video src={item.url} controls autoPlay />
          ) : (
            <img src={item.url} alt={item.original_name} />
          )}
          <div className="media-preview-name">{item.original_name}</div>
        </div>
      )}
    </Modal>
  );
}
